import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonTop } from '/src/components';
import { useAuthContext, useCartContext, useModalsContext } from '/src/providers';
import Mobile from './Mobile';
import Menu from './Menu';
import * as styles from './styles.scss';

const Right = () => {
    const { isAuth, logout, isLoadingAuth } = useAuthContext();
    const { showModal, MODALS_TYPES } = useModalsContext();
    const {
        cart: {
            total_quantity
        },
        isLoadingCart,
    } = useCartContext();
    const navigate = useNavigate();
    const isLoading = isLoadingAuth || isLoadingCart;

    const handleShowAccount = () => showModal(MODALS_TYPES.ACCOUNT);
    const handleShowCart = () => showModal(MODALS_TYPES.CART);

    return (
        <div className={styles.actions}>
            <Menu
                isAuth={isAuth}
                logout={logout}
                handleShowAccount={handleShowAccount}
                account={() => navigate('/customer')}
                disabled={isLoading}
            />
            <ButtonTop
                className={styles.list}
                onClick={isAuth ? () => navigate('/customer/wish-lists') : handleShowAccount}
                aria-label="Wish list"
                disabled={isLoading}
            />
            <ButtonTop
                className={styles.basket}
                onClick={handleShowCart}
                aria-label="Basket"
            >
                {!!total_quantity && <span>{total_quantity}</span>}
            </ButtonTop>
            <Mobile />
        </div>
    );
};

export default Right;
